import React from 'react';
import PropTypes from 'prop-types';


const CountryLabel = ({countryName}) => (
    <div className={`country-label country-label--${countryName.toLowerCase()}`}>
        <i className={`icon icon--${countryName.toLowerCase()}`} />
        <span>{countryName}</span>
    </div>
);

CountryLabel.propTypes = {
    countryName: PropTypes.string.isRequired,
};

export default CountryLabel;



// WEBPACK FOOTER //
// ./src/components/CountryLabel.js